export default "__VITE_ASSET__DR3ZdU6Y__"